export default "__VITE_ASSET__2758c4f0__"